import {
  createContext,
  memo,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { TvToastContainer, ToastContainerRef } from './toast_container';

const ToastContext = createContext<ToastContainerRef | null>(null);

type Props = {
  children: React.ReactNode;
};

export function useTvToast() {
  return useContext(ToastContext);
}

export const TvToastProvider = memo<Props>(({ children }) => {
  const toastRef = useRef<ToastContainerRef>(null);
  const [refState, setRefState] = useState<ToastContainerRef | null>(null);

  useEffect(() => {
    setRefState(toastRef.current);
  }, []);

  return (
    <ToastContext.Provider value={refState}>
      {children}
      <TvToastContainer ref={toastRef} />
    </ToastContext.Provider>
  );
});
